import { render } from "./AddNewAdmin.vue?vue&type=template&id=3b58ec6a&scoped=true"
import script from "./AddNewAdmin.vue?vue&type=script&lang=js"
export * from "./AddNewAdmin.vue?vue&type=script&lang=js"

import "./AddNewAdmin.vue?vue&type=style&index=0&id=3b58ec6a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b58ec6a"]])

export default __exports__